import { connect } from 'react-redux';
import React from 'react';
import { Button } from 'module-tsl-ui-elements';
import { setup as setupMz, emitPageView } from '../../modules/Mz';
import BaseComponent from './BaseComponent';
import HeaderNav from './HeaderNav';
import { getMoreSaved } from '../../modules/SavedModule';
import SavedRow from './SavedRow';

@connect((state) => ({
  items: state.savedModule.saved,
  loaded: state.savedModule.savedLoaded,
  allLoaded: state.savedModule.savedAllLoaded,
  isAuthenticated: state.profileModule.isAuthenticated,
  selectedResources: state.savedModule.selection,
}), { getMoreSaved, setupMz, emitPageView })
export default class Saved extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = { numOfSavedResourcesToShow: 10 };
  }

  componentDidMount() {
    if (this.props.isAuthenticated && this.props.items.length === 0) this.props.getMoreSaved();
    this.props.setupMz('resource.dash-fav');
    if (!window.emitPageView) return window.emitPageView = true; // eslint-disable-line no-return-assign
    this.props.emitPageView();
  }

  render() {
    const { loaded, items, allLoaded } = this.props;

    const bodyLoading = (
      <div className="text-center my-2">
        <Button loading>Loading</Button>
      </div>
    );
    const bodyWithItems = this.props.items.map((item, i) => <SavedRow key={i} item={item} index={i} />);
    if (!loaded) bodyWithItems.push(bodyLoading);
    const bodyNoItems = loaded ? (<div className="dashboard-card__container" key={'no-content'}>
      You don't have any resources to be displayed here.
    </div>) : bodyLoading;
    const body = (items && items.length) ? bodyWithItems : bodyNoItems;
    document.title = 'My Resources dashboard - teaching resources - Tes';
    return (
      <div>
        <div className="container-fluid-max margin-bottom-xl">
          <div className="row">
            <div className="tes-panel">
              <HeaderNav route="saved" />
              <div className="tes-panel__body tes-panel__body--sm">
                {body}
                {(!allLoaded && loaded) && <div className='text-center my-2'>
                  <Button theme='secondary' onClick={() => this.props.getMoreSaved()}>
                    Show more
                  </Button>
                </div>}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
